import React, {useEffect, useState} from "react";
import {Row, Col, Transfer, Button, Popover} from "antd";
import {isEmpty} from "lodash";
import UserInfoCard from "../UserInfoCard/UserInfoCard";
import UserSelect from "../UserSelect/UserSelect";
import compareStringsWithPoints from "../../../../lib/utils/compareStringWithPoints";

const styles = {
  transfer: {
    height: "60vh",
  },
  transferList: {
    width: "100%",
    height: "60vh",
  },
};

export default function AdministrationBlockPermissions(props) {
  const {
    users,
    permissions,
    permissionsLoading,
    selectedUser,
    handleSelectUser,
    handleBlockPermissionsToUser,
    selectable = true,
  } = props;

  const [transferData, setTransferData] = useState([]);
  const [targetKeys, setTargetKeys] = useState([]);
  // const [initBlockedPermissions, setInitBlockedPermissions] = useState([]);
  const [isDisabledButton, setIsDisabledButton] = useState(true);

  useEffect(() => {
    setTransferData(
      permissions.map((permission) => ({
        key: permission.id,
        id: permission.id,
        alias: permission.alias,
        dsc: permission.dsc,
      }))
    );
  }, [permissions, permissionsLoading]);

  useEffect(() => {
    if (!isEmpty(selectedUser)) {
      const roleExcludePermissions = selectedUser.excludedPermissions
        .map((item) => item)
        .sort((a, b) => compareStringsWithPoints(a.alias, b.alias))
        .map((item) => item.id);
      setTargetKeys(roleExcludePermissions);
      // setInitBlockedPermissions(roleExcludePermissions);
    }
  }, [selectedUser]);

  const handleChange = (nextTargetKeys) => {
    // if (
    //   nextTargetKeys.length === initBlockedPermissions.length &&
    //   nextTargetKeys.every((item) => initBlockedPermissions.includes(item))
    // )
    //   setIsDisabledButton(true);
    // else setIsDisabledButton(false);
    setIsDisabledButton(false)
    setTargetKeys([...nextTargetKeys]);
  };

  return (
    <>
      <Row gutter={[16, 16]}>
        <Col span={8}>
          {selectable && <UserSelect users={users} handleChangeUser={handleSelectUser}/>}
          {!isEmpty(selectedUser) && <UserInfoCard user={selectedUser}/>}
        </Col>
        <Col flex="1">
          <Transfer
            dataSource={transferData}
            targetKeys={targetKeys}
            onChange={handleChange}
            titles={["Доступные привилегии", "Заблокированные привилегии"]}
            render={(item) => <Popover content={item.dsc}>{item.alias}</Popover>}
            showSearch
            filterOption={(inputValue, item) =>
              item?.dsc && (item.alias.toLowerCase().includes(inputValue.toLowerCase()) ||
                item.dsc.toLowerCase().includes(inputValue.toLowerCase()))
            }
            style={styles.transfer}
            listStyle={styles.transferList}
            disabled={isEmpty(selectedUser)}
          />
        </Col>
      </Row>
      <Row className="row_buttons" justify="end">
        <Button
          type="primary"
          onClick={() => {
            handleBlockPermissionsToUser(targetKeys);
            setIsDisabledButton(true)
          }}
          htmlType="button"
          disabled={isDisabledButton}
        >
          Применить
        </Button>
      </Row>
    </>
  );
}
